// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"dbd41cb8","760":"f22c2215"}[chunkId] + ".css";
};